import parcoursJson from './SimulateurB2C2.1.0.json';
const parcours = {
  ...parcoursJson,
};

export default parcours;
